import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../../Data/UserContext";
import { NoIndexHelmet } from "../shared/SharePageHelmet";

const PREFS_PATH = "/account?t=preferences";
const LOGIN_PATH = "/login";
/** Path to return to after login (with leading slash so window.location.href = deeplink works from /login) */
const BACK_PARAM = "/opt-in";

/**
 * Handles /opt-in URL:
 * - Logged in: redirect to Account page with Preferences tab.
 * - Logged out: redirect to login with deeplink so after sign-in user lands on preferences.
 */
export function PreferencesRedirect() {
  const { user, loading } = useUser();

  if (loading) {
    return (
      <>
        <NoIndexHelmet />
        <div className="app-loading-shell" aria-hidden="true" />
      </>
    );
  }

  if (user) {
    return (
      <>
        <NoIndexHelmet />
        <Navigate to={PREFS_PATH} replace />
      </>
    );
  }

  return (
    <>
      <NoIndexHelmet />
      <Navigate to={`${LOGIN_PATH}?back=${encodeURIComponent(BACK_PARAM)}`} replace />
    </>
  );
}

export default PreferencesRedirect;
